import { useState } from "react";
import { toast } from "sonner";
import { BellRing } from "lucide-react";
import { Input } from "@/components/ui/input";
import { api, errMsg } from "@/lib/api";

export const NotifyMeForm = ({ query }) => {
  const [f, setF] = useState({ name: "", phone: "", consent: false });
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { await api.post("/waitlist", { ...f, query }); setDone(true); } catch (er) { toast.error(errMsg(er)); } finally { setBusy(false); }
  };
  if (done) return <p className="text-sm font-semibold text-secondary bg-secondary/10 rounded-xl p-3" data-testid="notify-me-done">Thanks {f.name.split(" ")[0]}! We'll WhatsApp you as soon as we start delivering to {query}.</p>;
  return (
    <form onSubmit={submit} className="rounded-xl border border-stone-200 p-3 space-y-2" data-testid="notify-me-form">
      <p className="flex items-center gap-2 text-sm font-bold text-primary"><BellRing className="w-4 h-4" strokeWidth={1.5} /> Notify me on WhatsApp when you deliver here</p>
      <div className="flex gap-2">
        <Input value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} placeholder="Your name" className="h-10 rounded-full px-4" data-testid="notify-me-name" />
        <Input value={f.phone} onChange={(e) => setF({ ...f, phone: e.target.value.replace(/\D/g, "").slice(0, 10) })} placeholder="10-digit mobile" inputMode="numeric" className="h-10 rounded-full px-4" data-testid="notify-me-phone" />
      </div>
      <label className="flex items-start gap-2 text-xs text-stone-600">
        <input type="checkbox" checked={f.consent} onChange={(e) => setF({ ...f, consent: e.target.checked })} className="mt-0.5 accent-[#1A2E1C]" data-testid="notify-me-consent" />
        I agree to receive a WhatsApp message from Mukti Fresh when delivery starts in my area.
      </label>
      <button disabled={busy || f.name.trim().length < 2 || f.phone.length !== 10 || !f.consent} className="h-10 px-5 rounded-full bg-primary text-white text-sm font-bold disabled:opacity-40 active:scale-95 transition-transform" data-testid="notify-me-submit">
        {busy ? "Saving…" : "Notify me"}
      </button>
    </form>
  );
};
